import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiLoader, FiFileText, FiUser} = FiIcons;

export const LoadingSpinner = ({ size = 'md' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-6 h-6',
    lg: 'w-8 h-8',
    xl: 'w-12 h-12'
  };

  return (
    <div className="flex items-center justify-center">
      <SafeIcon 
        icon={FiLoader} 
        className={`${sizeClasses[size]} animate-spin text-blue-600`} 
      />
    </div>
  );
};

export const PageLoading = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="w-64 h-64 relative">
        <video
          autoPlay
          loop
          muted
          playsInline
          className="w-full h-full object-cover rounded-lg"
        >
          <source src="/vdo/thinking.mp4" type="video/mp4" />
          <img
            src="/images/thinking.png"
            alt="loading"
            className="w-full h-full object-cover rounded-lg"
          />
        </video>
      </div>
    </div>
  );
};

export const TableLoading = ({ rows = 5 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: rows }).map((_, index) => (
        <div key={index} className="flex items-center space-x-4 p-4 animate-pulse">
          <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
          <div className="flex-1 space-y-2">
            <div className="h-4 bg-gray-200 rounded w-3/4"></div>
            <div className="h-3 bg-gray-200 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const CardLoading = () => {
  return (
    <div className="bg-white rounded-lg shadow p-6 animate-pulse">
      <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
      <div className="space-y-2">
        <div className="h-4 bg-gray-200 rounded"></div>
        <div className="h-4 bg-gray-200 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 rounded w-4/6"></div>
      </div>
    </div>
  );
};

export const EmptyState = ({ 
  icon = FiFileText, 
  title = "ไม่มีข้อมูล", 
  description = "ไม่พบข้อมูลในขณะนี้",
  action = null 
}) => {
  return (
    <div className="text-center py-12">
      <SafeIcon icon={icon} className="text-4xl text-gray-400 mx-auto mb-4" />
      <h3 className="text-lg font-medium text-gray-900 mb-2">{title}</h3>
      <p className="text-gray-500 mb-4">{description}</p>
      {action}
    </div>
  );
};

export default LoadingSpinner;
